import { axios } from '@Root/API'

export const updateFieldMapping = (id, payload) => {
  return axios.put(`cognito-form-field-mappings/${id}`, payload)
}
